import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from '../lib/analytics';

/**
 * Fires a $pageview event on every react-router navigation, including the
 * initial mount. Mount this once, anywhere inside <BrowserRouter>.
 */
const PageviewTracker = () => {
  const location = useLocation();
  useEffect(() => {
    trackPageview(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
};

export default PageviewTracker;
